import { accordionHtml, escapeHtml, readAccordionPanels, replaceWidgetNode } from './markup';
import { bindRepeatable, dialogStyles as s, itemRow, openFormDialog } from './dialogHelpers';

const panelFields = (panel = {}) =>
  `<label class="${s.field}"><span>Title</span>
    <input class="jodit-input mc-acc-title" type="text" placeholder="e.g. Key idea" value="${escapeHtml(
      panel.title || '',
    )}" />
  </label>
  <label class="${s.field}"><span>Content</span>
    <textarea class="jodit-input mc-acc-body" rows="2" placeholder="What learners see when they expand this panel">${escapeHtml(
      panel.body || '',
    )}</textarea>
  </label>`;

const panelRow = (panel = {}) =>
  itemRow({ label: 'Panel', fields: panelFields(panel) });

export const openAccordionDialog = (editorInstance, existingNode = null) => {
  const panels = existingNode
    ? readAccordionPanels(existingNode)
    : [{ title: '', body: '' }, { title: '', body: '' }];

  const { dialog, form } = openFormDialog(editorInstance, {
    title: existingNode ? 'Edit accordion' : 'Insert accordion',
    submitLabel: existingNode ? 'Update' : 'Insert',
    minWidth: 560,
    errorMessage: 'Add a title or content to at least one panel.',
    html: `<p class="${s.hint}">Each panel has a title learners tap to expand. Keep titles short so the list stays easy to scan.</p>
      <div class="${s.list}">${panels.map(panelRow).join('')}</div>
      <button type="button" class="jodit-ui-button ${s.add}">+ Add panel</button>`,
    onSubmit: (submittedForm) => {
      const next = [...submittedForm.querySelectorAll(`.${s.row}`)]
        .map((row) => ({
          title: row.querySelector('.mc-acc-title')?.value.trim() || '',
          body: row.querySelector('.mc-acc-body')?.value.trim() || '',
        }))
        .filter((panel) => panel.title || panel.body);
      if (!next.length) {
        return false;
      }
      replaceWidgetNode(editorInstance, existingNode, accordionHtml(next));
      return true;
    },
  });

  bindRepeatable(form, dialog, {
    listSelector: `.${s.list}`,
    rowSelector: `.${s.row}`,
    addSelector: `.${s.add}`,
    makeRow: () => panelRow(),
  });
};

export const getAccordionButton = () => ({
  name: 'mcAccordion',
  tooltip: 'Accordion',
  exec: (editorInstance) => openAccordionDialog(editorInstance),
});
